import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FilePondOptions } from 'filepond';
import { environment } from 'src/environments/environment';
import { FileuploaderFilepondService } from './fileuploader.filepond.service';
import { TranslateService } from '@ngx-translate/core';
import { FilePondComponent } from 'ngx-filepond';


@Component({
  selector: 'app-fileuploader-filepond',
  templateUrl: './fileuploader-filepond.component.html',
  styleUrls: ['./fileuploader-filepond.component.css']
})

export class FileuploaderFilepondComponent implements OnInit {
  @Input() model: string;
  @Input() summary: string;
  @Input() fileTypes: string;
  @Input() maxFiles: number;

  @ViewChild('myPond') myPond: FilePondComponent

  pondOptions: FilePondOptions = {
    allowMultiple: true,
    allowFileTypeValidation: true,
    acceptedFileTypes: [],
    maxFiles: 5,
    allowFileSizeValidation: true,
    maxFileSize: '1024MB',
    labelFileProcessingComplete: "Upload to memory complete, don't forget to SAVE the item",


    server: {
      url: environment.api_base,
      process: (fieldName, file, metadata, load, error, progress, abort) => {

            this.getFiledetails(file);
              //to set upload complete
              load("");

              return {
                abort: () => {
                    // Let FilePond know the request has been cancelled
                    abort();
                },
              };
            

            // Should expose an abort method so the request can be cancelled
      },
      revert: (uniqueFileId, load, error) => {
             
        this.removeFileDetails();
        // Should call the load method when done, no parameters required
        load();
    },

  }
}

  pondFiles: FilePondOptions["files"] = [

  ]

  async getFiledetails(file: any) {
      await this.fileuploaderService.readFileContent(file)
        .toPromise()
        
        .then(
          res => {
            this.fileuploaderService.fileContentLoaded();
            }
         )  
}

  removeFileDetails()
  {
    this.fileuploaderService.fileRemoved();
  }

  constructor(public fileuploaderService: FileuploaderFilepondService,
    public translate: TranslateService){
    }

    ngOnInit(){

    this.translate
    .get(['filepond-labelIdle'])
    .subscribe((translations: string) => {
      this.pondOptions.labelIdle = translations['filepond-labelIdle'];
    });
    if (this.fileTypes && this.fileTypes.length > 0)
    {
      this.pondOptions.acceptedFileTypes = this.fileTypes.split(',').slice();
    }

    if (this.maxFiles)
    {
      this.pondOptions.maxFiles = this.maxFiles;
    }

  }

  pondHandleInit() {
    console.log('FilePond has initialised', this.myPond);
  }

  pondHandleStart() {
    //do nothing
  }

  pondHandleAddFile()
  {
    console.log('FilePond add file', this.myPond);
  }
}
